<!-- 队式赛 选手签到 -->
<template>
<div class="detail-wrap">
    <div class="sign-wrap sign" v-if="pageNum === 1">       
        <div class="sign-title overflow-ellipsis-2">{{ title }}</div>
        <el-input v-model="username" placeholder="选手姓名"></el-input>
        <el-input class="mg-t-20" v-model="partnerName" placeholder="搭档姓名"></el-input>
        <el-button class="sign-btn" type="primary" @click="handleSign" round>点击签到</el-button>        
    </div>
    <div class="sign-wrap" v-if="pageNum === 2">
        <div class="back-pre-page">
            <button class="back-page-btn" @click="backPage(1)">返回</button>
            <div class="time" v-if="isShowCountDown">时间：{{ countTime }} </div>
            <div class="ramain-txt" v-else>{{ errMsg }}</div>
        </div>        
        <div class="mg-t-20  size20">{{errorShow}}</div>        
        <div class="mg-t-20 mg-b-10 size20">第{{round}}轮对阵</div>
        <table>
             <thead>
                 <tr>                   
                    <th>桌号</th>
                    <th>方位</th>   
                    <th>选手姓名</th>              
                 </tr>
             </thead>
             <tbody>    
                <tr v-for="(item,index) in dataList" :key="index">               
                <td>{{item.deskNo }}</td>
                <td>{{item.seat}}</td>
                <td>{{ item.username }} [{{item.id }}]</td>
                </tr>  
             </tbody>
         </table>
         <button class="mg-t-20 score-btn-con"  v-if="isShow" @click="handleScore">记录比赛成绩</button>
    </div>
    <div class="score-sign" v-if="pageNum === 3">       
        <div class="back-pre-page">
            <div class="time" v-if="isShowCountDown">时间：{{ countTime }}</div>
            <button class="back-page-btn" @click="backPage(2)">返回</button>
            <el-button class="score-btn-con" style="margin-left: 30px;" v-if="gamesId > 3"
                @click="scoreConfirm" :disabled="disabled">{{ confirmBtn }}</el-button>  
        </div>       
        <div class="round-info">
            <span>第{{round}}轮 第{{deskNo}}桌</span>
            <el-button class="delete-score" :disabled="disabled" @click="modifyScore" >改</el-button>
        </div>
        <!-- 最终成绩 -->
        <div class="final-score">
            <div class="score-team">
            <div class="team-name-sign-large">东西（{{mainData.teamTypeWE}}）</div>
            <div class="team-score">{{finalScoreWE}}</div>
            </div>    
            <div class="vs-span">VS</div>    
            <div class="score-team">
            <div class="team-name-sign-large">南北（{{mainData.teamTypeSN}}）</div>
            <div class="team-score">{{finalScoreSN}}</div>
            </div>
        </div>  
        <!-- 级牌选择 -->
        <div class="level-section">
            <div class="section-title"><span>当前级牌选择</span>
            </div>
            <div class="card-pok">
                <div class="flex-col" v-for="item in originPok">
                    <span class="card-number"
                        :class="item.gamesNum !=='' && item.value === maxScoreWE? 'isLastGames': item.gamesNum !==''? 'isSelected': selectedCard == item.value ? 'newSelected': 'card-number'" @click="changeSelectCard(item)"
                    >{{ item.value }}</span>
                    <span class="games-num">{{ item.gamesNum ==='第0把'? '' : item.gamesNum }}</span>
                </div>            
            </div>
        </div>
        <!-- 本把升级 -->
        <div class="team-section">
            <div class="section-title">
            <span>本把升级</span>
            </div>    
            <div class="team-info-sign">
            <div class="team-name-sign home-team">
                <span>东西({{usernameWE}})</span><span class="teamType">({{mainData.teamTypeWE}})</span>
            </div>
            <div class="score-buttons">
                <button 
                    v-for="item in eastScores" 
                    class="score-btn"
                    :class="item.score === eastScore ? 'selected' : 'unselected'" 
                    :disabled="disabled"
                    @click="selectEastScore(item)"
                    >
                    {{item.score}}
                </button>
            </div>
            </div>    
            <div class="team-info-sign">
            <div class="team-name-sign away-team">
                <span>南北({{usernameNS}})</span><span class="teamType">({{mainData.teamTypeSN}})</span>
            </div>
            <div class="score-buttons">
                <button 
                    v-for="item in  westScores"                 
                    class="score-btn"
                    :class="item.score === westScore ? 'selected' : 'unselected'"                
                    :disabled="disabled"
                    @click="selectWestScore(item)">
                    {{item.score}}
                </button>
            </div>
            </div>
        </div>
        <!-- 队友信息 -->
        <div class="teammate-info">
            <div class="teammate-title">
            <span>队友信息</span>
            </div>
            <div class="teammate-details">
            <div class="teammate-card">
                <div class="teammate-table">
                <span>第{{teamDeskNo}}桌</span>
                </div>
                <div class="level-indicators">
                <div class="flex-col" v-for="item in originPokTeam" >
                    <span  
                        class="card-number"
                        :class="item.gamesNum !=='' && item.value === maxScoreSN ? 'isLastGames': item.gamesNum !==''? 'isSelected':'card-number'">{{ item.value }}</span>
                    <span class="games-num">{{ item.gamesNum ==='第0把'? '': item.gamesNum}}</span>
                </div>
                </div>
                <div class="teammate-score">
                东西: {{teammateData.usernameWE}}        
                <span class="mg-l-20">{{teammateScoreWE}}</span>
                </div>
                <div class="teammate-score">南北: {{teammateData.usernameSN}}
                <span class="mg-l-20">{{teammateScoreSN}}</span>
                </div>
            </div>
            </div>
            <div class="total-score">
                本队总分: {{finalTotalScore}}
            </div>
        </div>
    </div>     
    <!-- 广告轮播图 -->
    <div style="position:fixed;bottom: 0;width: 100%;">     
        <el-carousel height="150px" :interval="6000" arrow="never" indicator-position="none">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index" >
            <img :src="item.imageUrl"  style="width: 100%;height: 150px;"/>
        </el-carousel-item>
        </el-carousel>
    </div>   
</div>
</template>

<script>
import Qrcode from '@/components/Qrcode'
export default {
    name: 'teamSign',
    components: {
        Qrcode,
    },
    data() {
        return {
            isShow: false,
            pageNum: 1,
            username: '',
            partnerName: '',
            signUrl: '',
            publishId: '',
            dataList:[],
            bannerList: [],
            errorShow: '',
            title: '',
            round: 1,
            deskNo: 1,
            pubType: '1',
            gradeUpdate: false,
            originPok: [],
            cardWestEast: [],
            cardSouthNorth: [],
            scoreList: [],
            scoreAllList: [],
            thingPoker: 2,
            northSouthPoker: 2,
            gamesId: 1,
            disabled: false,
            scoreWestEast:0,
            scoreSouthNorth: 0, 
            confirmBtn: '确认提交',
            usernameWE: '',
            usernameNS: '',
            isShowCountDown: false,
            errMsg: '',
            countTime: '',
            countdownTimer: null,
            minute: 0,
            second: 0,
            checkList: [],  
            playStatus: false,
            maxScoreWE: '',
            maxScoreSN: '',
            finalScore: [],
            isActive: 1,
            deskNoNew: '',
            newRound: 1,
            // 新数据
            finalScoreWE: 0,
            finalScoreSN: 0,
            scorePokerWE: '',
            scorePokerSN: '',
            eastScore: 0,
            westScore: 0,
            selectedCard: '',
            teammateScoreWE: 0,
            teammateScoreSN: 0,
            teamDeskNo: '',
            mainData: {},//本队信息
            teammateData: {},//队友信息,
            originPokTeam: [],
            finalTotalScore: 0,
            eastScores: [
                { score: 1, status: 'unselected' },
                { score: 2, status: 'unselected' },
                { score: 3, status: 'unselected' }
            ],
            westScores: [
                { score: 1, status: 'unselected' },
                { score: 2, status: 'unselected' },
                { score: 3, status: 'unselected' }
            ],
            canSelectLevel: true,
            selectLevelTimer: null,
            disabledScore: false,
        }
    },
    created() {
        this.publishId = this.$route.query.id
        this.pubType = this.$route.query.type
        setTimeout(() => {
            this.initData()
        }, 300);
    },
    mounted() {       
        this.getBannerList()
    },
    methods: {
        // 赛事查询
        initData(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.publishId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    let list = result.map(item=>{                        
                        return{
                            title: item['主题'],
                            amount: item['参赛人数'],
                            address: item['赛事地点'],
                            sponsor: item['赞助'],
                            maxNum: item['每局最大升级数'],
                            round:  item['比赛轮数'] + 1,
                            maxRound: item['轮数']
                        }
                    })
                    this.title = list[0].title
                    this.round = list[0].round <= list[0].maxRound ? list[0].round : list[0].maxRound
                    this.maxNumber = list[0].maxNum
                }
            })
        },
        getBannerList(){
            let params = {
                opcode: 1069,
                i_serial_mark: this.publishId,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable
                    if(result.length > 0){
                        let arr = result.map(item=>{
                            return{
                                id: item['序号'],
                                imageUrl: item['广告图片'],
                                status: item['状态'],
                            }           
                        })
                        this.bannerList = arr
                    }
                }
            })
        },
        // 选手签到
        handleSign(){
            if(this.username === ''){
                this.$message.error("请输入选手姓名！")
                return false
            }
            if(this.partnerName === ''){
                this.$message.error("请输入搭档姓名！")
                return false
            }
            let params = {
                opcode: this.$code.SignIn,
                i_serial_mark:  this.publishId,
                v_player_no: '',
                v_player_name: this.username,
                v_player_phone: '',
                v_partner_no: '',
                v_partner_name: this.partnerName,
                v_partner_phone: '',
                c_status: 1,
            }    
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){     
                    this.$message.success(res.Message)               
                    this.playersId = this.$help.regexStr(res.Message)       
                    console.log(this.playersId)        
                    this.pageNum = 2
                    setTimeout(()=>{
                        this.initData()
                        this.getSignQuery()
                        this.getTimeQuery()
                    },100)                    
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        // 签到查询
        getSignQuery(){
            let params = {
                opcode: this.$code.SignQuery,
                i_serial_mark: this.publishId,
                i_players_number: this.playersId,
                i_round: this.round,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.isShow = true
                    let result = res.Data.DataTable
                    this.dataList = result.map(item=>{
                        return{
                            deskNo: item['桌号'],
                            id: item['选手编号'],
                            username: item['选手名称'],
                            company: item['协会（俱乐部）'],
                            seat: item['座位'],
                        }
                    })
                    this.deskNo = this.dataList[0].deskNo   
                    this.errorShow = ''  
                    let usernameWE = this.dataList.filter(i=>i.seat.includes('东-西'))
                    let usernameNS = this.dataList.filter(i=>i.seat.includes('南-北'))
                    this.usernameWE = usernameWE[0].username
                    this.usernameNS = usernameNS[0].username
                   
                    setTimeout(()=>{                       
                        this.getNewScore()
                    },200)             
                }else{
                    this.isShow = false
                    this.errorShow = res.Message
                    this.$message.error(res.Message)
                }
            })
        },
        backPage(n){
            this.pageNum = n
            this.newRound = 1
            this.initData()
            this.selectedCard = ''
            this.eastScore = 0
            this.westScore = 0
            this.disabled = false
        },
        handleScore(){    
            clearInterval(this.countdownTimer)
            this.getTimeQuery()   
            this.selectedCard = ''
            this.eastScore = 0
            this.westScore = 0
            this.getPok()
            setTimeout(()=>{
                if(this.playerStatus){
                    this.pageNum = 3                    
                    this.getNewScore()
                }else{
                    this.$message.error('请提醒裁判点倒计时，倒计时开始，方可记录成绩。')               
                }   
            },500) 
        },
        getPok(){
            let params = {
                opcode: this.$code.RoundCardsView,
                i_serial_mark: this.publishId,
                i_round: this.round,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable  
                    if(result.length > 0 ){
                        let list = result[0]['本轮级牌']           
                        let cardArray = list.split('-')
                        let pokerList = this.$help.generateCardArray(cardArray[0], cardArray[1])
                        
                        this.originPok = pokerList.map(value => ({
                            value,
                            label: value,
                            gamesNum: '',
                        }));                         
                        // console.log('数组牌',list,this.originPok)
                    }
                }
            })
        },
        // 选择扑克牌点数
        changeSelectCard(e) {
            const {value } = e
            if (!this.canSelectLevel) return;

            // 执行选中级牌的操作
            // console.log('选择了级牌：', value);
           

            // 设置定时器，5秒后恢复
            this.selectLevelTimer = setTimeout(() => {
                this.canSelectLevel = true;
            }, 5000);

            if(this.disabled){
                this.$message.error('本轮已完成，修改成绩请联系裁判!')
                return false
            }
            if(this.canSelectLevel){
                this.selectedCard = value
                this.disabledScore = true               
               
                if(value){
                    this.teamConfirm(value)
                }
                 // 禁用点击
                this.canSelectLevel = false
            }           
           
        },
        // 本局选择级牌
        teamConfirm(card){
            let params = {
                opcode: this.$code.SelectCards,
                i_serial_mark: this.publishId,
                i_round: this.round,
                i_games_id: this.gamesId,
                i_desk_no: this.deskNo,
                poker: card,
                i_players_number: this.playersId
            }
        this.$api._requestAPI(params).then(res=>{
            if (res.IsSuccess) {                   
                this.$message({
                    type: 'success',
                    message: '级牌选择成功，请选择升级数',
                    duration: 2000,
                    customClass: 'messsage-sign'
                })
                setTimeout(()=>{
                    this.eastScore = 0
                    this.westScore = 0
                    
                },100) 
            }else{
                this.$message.error(res.Message)
            }
        })
        },
        // 查询每轮全部局数的成绩
        getAllScore(){
            let params = {
                opcode: this.$code.GradeQuery,
                i_serial_mark: this.publishId,
                i_games_id: 0,
                i_desk_no: this.deskNo,
                i_round: this.round,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable
                    if(result.length > 0){
                    
                    let arr = result.map(item=>{
                        return{
                            id: item['选手编号'],
                            username: item['选手名称'],
                            partername: item['搭档名称'],
                            company: item['战队名称'],
                            gamesNum: item['局数'],
                            seat: item['座位'],
                            round: item['轮数'],
                            score: item['成绩'],
                            level: item['升级'],
                            team: item['主客队']
                        }
                    })                  
                    let list  = this.selectDeskNo(arr)                    
                    // let lastArr = list[list.length-1]
                    // this.gamesId = lastArr.gamesNum+1
                    let lastGames =  list.filter(i=> i.gamesNum === 111)  
                    console.log('haha',lastGames)
                    if(lastGames.length === 1){          
                        this.disabled = true
                    }
                    // console.log('查询每轮全部局数',list,'第几局', this.gamesId)
                    }
                }
            })
        },
        selectDeskNo(arr){
            let result = []
            arr.forEach(item => {
                if(!result.some(i => i.gamesNum === item.gamesNum )){
                    result.push({
                        gamesNum: item.gamesNum,
                        users: arr.filter(user => user.gamesNum === item.gamesNum)
                    })
                }
            });
            return result
         },
        // 每一局的分数
        scoreSubmit(){
            let params = {
                opcode: this.$code.ScoreSub,                
                i_serial_mark: this.publishId,
                i_players_number: this.playersId,
                i_round: this.round,
                i_games_id: this.gamesId,
                i_desk_no: this.deskNo,
                thing_poker: this.eastScore,
                northsouth_poker: this.westScore,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.getNewScore()
                    this.$message({
                        type: 'success',
                        message: res.Message,
                        duration: 2000,
                        customClass: 'messsage-sign'
                    })
                    this.disabledScore = false
                }else{
                    this.$message.error(res.Message)
                }                
            })
        },
        // 本局赛事确认
        scoreConfirm(){
            let params = {
                opcode: this.$code.ScoreConfirm,                
                i_serial_mark: this.publishId,
                i_players_number: this.playersId,
                i_round: this.round,
                i_desk_no: this.deskNo,
                thing_poker: this.eastScore,
                northsouth_poker: this.westScore,
            }
            // console.log(params)
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.disabled = true
                    this.confirmBtn = '本轮成绩已提交！'
                    this.$message.success(res.Message)
                    setTimeout(()=>{                        
                        this.getNewScore()
                    },500)
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        modifyScore(){      
            this.$confirm('确定删除这一把的分数吗？', 
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'custom-cancel-button',
                    type:'warning',
                    customClass: 'my-messageBox'
                }
            ).then(res=>{
                if(this.gamesId <= 1){
                    this.gradeUpdate = false
                    this.selectedCard = ''
                    this.$message.error('成绩已清除，请重新选择成绩')
                }else{
                    this.gradeUpdate = true
                    this.eastScore = '删除'
                    this.westScore = '删除'
                    this.gamesId = this.gamesId -1 
                    this.selectedCard = ''
                    if(this.gradeUpdate){
                        setTimeout(() => {
                            this.scoreSubmit()
                        },100)
                    }                    
                }
            }).catch(err=>{

            })  
        },
        // 倒计时查询
        getTimeQuery(){
            let params = {
                opcode: this.$code.TimerQuery,
                i_serial_mark: this.publishId,
            }
        this.$api._requestAPI(params).then(res=>{
            if(res.IsSuccess){
            let list = res.Data.DataTable
            let result = list.map(i=>{
                return{
                    t: i['倒计时'],
                    status: i['状态'],
                }
            })
            let arr = result[0]
            if(arr.status === '开始'){
              let arr2 = arr.t.split(':')
                if(Number(arr2[0]) > 0){
                    this.minute = Number(arr2[0])
                    this.second =  Number(arr2[1])
                }else{
                  this.minute = 0
                  this.second =  Number(arr2[1])
                }  
                this.countDownFn()  
            }else if(arr.status === '暂停'){
              // 暂停状态 
              this.countTime = result[0].t
              clearInterval(this.countdownTimer)
            }else if(arr.status === '结束'){
              // 结束状态 
              this.countTime = '00:00'
              clearInterval(this.countdownTimer)
            }     
            this.isShowCountDown = true
            this.playerStatus = true 
            }else{
                this.isShowCountDown = false
                this.errMsg = '倒计时未开始！'
                this.playerStatus = false
            }
        })
    },
    handleCancel(){
        this.showSeatScore = false;
        this.checkList = []
    },
    // 倒计时方法
    countDownFn(){
        // console.log(this.minute,this.second)
        let remainingTime = this.minute * 60 + this.second
        this.countdownTimer = setInterval(()=>{
        var minutes = Math.floor(remainingTime / 60);
        var seconds = remainingTime % 60;
        // 在页面上更新倒计时显示
        let displayTime = minutes + ':' + (seconds < 10 ? '0' + seconds : seconds)
        this.countTime = displayTime
        if(remainingTime > 0){
            this.playStatus = true
            remainingTime--;
        }else{
            // 当倒计时结束时清除定时器
            clearInterval(this.countdownTimer)
        }
        },1000)
    },
    getNewScore(){
        let params = {
            opcode: this.$code.ScoreQueryNew,
            i_serial_mark: this.publishId,
            i_round: this.round,
            i_desk_no: this.deskNo
        }
        this.$api._requestAPI(params).then(res=>{
            if(res.IsSuccess){
                let arr = res.Data.DataTable
                let newArr = arr.map(item=>{
                    let score = item['成绩'] ? JSON.parse(item['成绩']): ''
                    let playing = item['进行中']? JSON.parse(item['进行中']): ''
                    return{
                        teamTypeWE: item['东西'],
                        teamTypeSN: item['南北'],
                        totalScoreWE: item['东西总升级'] || 0,
                        totalScoreSN: item['南北总升级'] || 0,
                        deskNo: item['桌号'],  
                        usernameWE: item['东西选手'],
                        usernameSN:item['南北选手'],      
                        score: score,
                        playing: playing
                    }
                })
                let gamesArr = newArr.map(item=>{                                      
                    return{
                        score: item.score,
                        playing: item.playing                         
                    }
                })
                console.log(gamesArr)
                console.log(newArr)
                let scoreArr = gamesArr[0].score
                let playArr = gamesArr[0].playing
                if(playArr && Object.keys(playArr).length > 0){
                // 情况1：playing 有值，取第一个键的数字部分
                const playingKey = Object.keys(playArr)[0]; // 例如："第8把"
                this.gamesId = parseInt(playingKey.replace(/[^0-9]/g, '')); // 提取数字 8
                }else{
                // 情况2：playing 没有值，取 score 最后一个键的数字部分加1
                    const scoreKeys = Object.keys(scoreArr);
                    if (scoreKeys.length > 0) {
                        const lastScoreKey = scoreKeys[scoreKeys.length - 1]; // 例如："第7把"
                        const lastScoreNumber = parseInt(lastScoreKey.replace(/[^0-9]/g, '')); // 提取数字 7
                        this.gamesId = lastScoreNumber + 1;               
                    }else{
                        this.gamesId = 1
                    }
                }

                // 第几把
                let WE = gamesArr[0].score
                let SN = gamesArr[1].score
                // 本队信息
                let main = newArr[0]
                // 获取队友信息
                let teammateArray = newArr[1]
                let totalScore = [];
                let scoreSN = []
                for (var key in WE) {
                    if (WE.hasOwnProperty(key)) {
                    var value = WE[key];
                    var newObj = {
                        key: key,
                        value: value
                    };                        
                    totalScore.push(newObj);
                }
                }
                for (var key in SN) {
                    if (SN.hasOwnProperty(key)) {
                        var value = SN[key];
                        var newObj = {
                            key: key,
                            value: value
                        }; 
                        scoreSN.push(newObj);
                    }
                }
                if(totalScore.length > 0){
                    this.maxScoreWE = totalScore[totalScore.length-1].value
                
                }
                if(scoreSN.length > 0){
                    this.maxScoreSN= scoreSN[scoreSN.length-1].value
                }
                let scoreObjWE = JSON.parse(JSON.stringify(this.originPok))
                // 遍历数组2，并基于array1中的匹配来更新gamesNum
                scoreObjWE.forEach(function(obj2) {
                    // 在array1中查找与obj2.value匹配的对象
                    var matchingObj1 = totalScore.find(function(obj1) {
                        return obj1.value === obj2.value;
                    });                    
                    // 如果找到匹配的对象，则更新gamesNum
                    if (matchingObj1) {
                        obj2.gamesNum = matchingObj1.key;                    
                    }else{
                        obj2.gamesNum = ''
                    }                   
                });
                let scoreObjSN = JSON.parse(JSON.stringify(this.originPok))
                scoreObjSN.forEach(function(obj2) {
                    // 在array1中查找与obj2.value匹配的对象
                    var matchingObj1 = scoreSN.find(function(obj1) {
                        return obj1.value === obj2.value;
                    });                    
                    // 如果找到匹配的对象，则更新gamesNum
                    if (matchingObj1) {
                        obj2.gamesNum = matchingObj1.key;   
                    }else{
                        obj2.gamesNum = ''
                    }
                });  
                let teamTotalScore = 0
                if( this.usernameWE.includes(this.username)){
                    teamTotalScore = main.totalScoreWE + teammateArray.totalScoreSN
                }
                if(this.usernameNS.includes(this.username)){
                    teamTotalScore = main.totalScoreSN + teammateArray.totalScoreWE
                }  
                this.mainData = main
                this.finalScoreWE = main.totalScoreWE
                this.finalScoreSN = main.totalScoreSN
                this.teammateScoreWE = teammateArray.totalScoreWE
                this.teammateScoreSN = teammateArray.totalScoreSN
                this.teamDeskNo = teammateArray.deskNo
                this.teammateData = teammateArray
                this.originPok = scoreObjWE
                this.originPokTeam = scoreObjSN
                this.finalTotalScore = teamTotalScore
                // console.log(scoreObjWE,this.tableRowPokWE)              
            }            
        })
    },
    // 选择东西队伍得分
    selectEastScore(e) {
        const score = e.score
        console.log('东西分',score)
       
        if(this.disabledScore){ 
            this.eastScore  = score
            this.westScore = 0
             if(score){
                this.scoreSubmit()
            }
        }else{
            this.$message.error('本把分数已提交，请选择下一把级牌')
        }
       
    },
    selectWestScore(e){
        const score = e.score
        console.log('南北分',score)
        if(this.disabledScore){ 
            this.westScore = score
            this.eastScore= 0
            if(score){
                this.scoreSubmit()
            }
        }else{
            this.$message.error('本把分数已提交，请选择下一把级牌')
        }       
    },
    getGamesNumClassWE(row){
        if(row.gamesNum !=='' && row.value === this.maxScoreWE){            
            return 'isLastGames'
        }else 
        if(row.gamesNum !==''){
            return 'isSelected'
        }else{
            return ''
        }
    },
    getGamesNumClassSN(row){
        if(row.gamesNum !=='' && row.value === this.maxScoreSN){            
            return 'isLastGames'
        }else 
        if(row.gamesNum !==''){
            return 'isSelected'
        }else{
            return ''
        }
    },
    },
    destroyed(){
        clearInterval(this.countdownTimer)
    }
}
</script>
<style lang='scss' scoped>
@media screen and (max-width:768px){
    table {
     width: 100%;
     border-collapse: collapse;
   }
   th, td {
     border: 1px solid #999;
     padding: 8px;
     text-align: left;
     font-size: 16px;
   }
   tr:nth-child(even) {
    //  background-color: #bbffbb;
   }
   thead th {
     background-color: #f2f2f2;
     font-size: 18px;
     text-align: center;
   }
   .table-label {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 10px;
     background-color: #f9f9f9;
     border: 1px solid #ddd;
   } 
   .sign-page{
    width: 100%;
    background-color: #f5f5f5;
   }
  .detail-wrap{    
    height: 100vh;
    margin: 0 auto;
    border: 0;    
  }
  .head-color{
    height: 30px;
    background-color: #fca850;
  }
  .sign-wrap-cell{
    padding-top: 20px;
  }
  .sign-wrap{
    width: 90vw ;
    padding-top: 20px;
    margin: 0 auto;
  }
  .sub-name{
    line-height: 30px;
  }
  .wrap-line{
    line-height: 25px;
  }
  .sign{
    width: 90%;
    height: 40vh;
    border-radius: 10px;
    background-color: #fff;
  }
  .sign-title{
    text-align:center;
    padding-bottom: 30px;
    font-size: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-break: break-all;
    
  }
  .sign-btn{
    width: 100%;
    margin-top: 30px;
    text-align: center;
  }
  .num-txt{
    margin-left: 15px;
    padding: 8px 15px;
    color:#fff;
    border: none;
    background-color: rgb(242, 31, 45);
  }
  .number{
    padding:10px;
    border: none;
    margin-right: 2px;
    color:#fff;
    cursor: pointer;
    background-color: forestgreen;
  }

  .card-number{    
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    color:#fff;
    font-size: 18px;
    text-align: center;
    margin-right: 5px;
    background-color: #3bcdf1;
    box-shadow:  2px 2px 10px rgba(61, 38, 38, 0.4);
  }
  .overflow-ellipsis-2{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
  }
  .card-pok{
    display: flex;
    flex-wrap: wrap;
  }
  .mg-tb-10{
    margin: 10px 0;
  }
  .back-pre-page{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px dashed #eaeaea;
    }
  .ramain-txt{
    font-size: 20px;
    color: red;
    margin-left: 20px;
  }
.direction{
    display: flex;
    align-items: center;
    margin: 10px 0;
    color:#000;
    font-weight: bold;
}

.table-score {  
    display: flex;  
    flex-direction: column;  
    border: 1px solid #ccc;  
    overflow: scroll;
    margin: 15px 0 0px 0;    
}      
.table-tr {  
    display: flex;  
}  
.table-td {  
    flex: 1; /* 让单元格宽度平分 */  
    text-align: center; /* 文本居中 */  
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc; /* 单元格之间分隔线 */  
    padding: 5px 8px;
    min-width: 15px;
}
 .tip-bottom{
    text-align: center;
    padding: 10px 0 30px 0;
}
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

::-webkit-scrollbar-track {
  background-color: #FFFFFF;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #39b54a;
  border-radius: 10px;
}
}
.games-num{
    font-size: 12px;
    margin:2px 2px 8px 2px;
}
.isSelected{
    background-color: #faca09;   
}
.isLastGames{
    background-color: #f75e00
}
.newSelected{
    background-color: #67c23a;
}
.score-round{
    background-color: #f06414;
    border: none;
}
.filter-item{
  padding: 4px 8px;
  border: 1px solid #e1e1e1;
  border-radius: 16px;
  margin-right: 10px;
}
.isChecked{
  color: red;
  padding: 4px 8px;
  border: 1px solid rgb(233, 52, 52);
  border-radius: 16px;
  margin-right: 10px;
  background-color: #fad5d5;
}
</style>
<style lang='scss' scoped>
.my-messageBox .el-message-box__message{
    font-size: 20px !important;
}
.custom-cancel-button {
    margin-left: 20px;
}
.my-messageBox  .el-message-box__btns{
    display: flex;
    font-size: 20px !important;
    flex-direction: row-reverse;
    justify-content: center;
}
.my-messageBox .el-button--small{
    font-size: 20px !important;
}
.score-sign{
    background: #f0f2f5;
    padding-bottom: 150px;
}
.time{
    font-size: 16px;
    font-weight: bold;
    color: #1e5aa5;
    display: flex;
    align-items: center;
    background: #e8f0fe;
    padding: 4px 8px;
    border-radius: 4px;
    box-shadow: 0 1px 2px rgba(30, 90, 165, 0.1);
}
.score-btn-con{
    padding: 5px 8px;
    font-size: 16px;
    border: none;
    color: #fff;
    border-radius: 5px;
    background-color: #2a6dc5;
}
.back-page-btn{
    padding: 5px 8px;
    font-size: 16px;
    border: none;
    color: #fff;
    border-radius: 5px;
    background-color: #2a6dc5;
}
.round-info {
  text-align: center;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  color: white;
  padding: 5px;
  background: linear-gradient(135deg, #1e5aa5, #2a6dc5);
  border-radius: 10px;
  box-shadow: 0 3px 6px rgba(30, 90, 165, 0.3);
  position: relative;
  overflow: hidden;
}
.delete-score{
  background-color: red;
  color: #fff;
  display: inline;
  font-size: 14px;
  border: none;
  padding: 5px 10px;
  margin-left: 30px;
}
.final-score {
  text-align: center;
  margin-bottom: 15px;
  font-size: 16px;
  background: linear-gradient(135deg, #1e5aa5, #2a6dc5);
  color: white;
  padding: 15px;
  border-radius: 6px;
  box-shadow: 0 3px 6px rgba(30, 90, 165, 0.3);
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.score-team {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  z-index: 1;
}

.team-name-sign-large {
  font-size: 16px;
  font-weight: bold;
}
.team-score {
  font-size: 16px;
  font-weight: bold;
  background: white;
  color: #1e5aa5;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.vs-span {
  font-size: 16px;
  font-weight: bold;
  background: white;
  color: #1e5aa5;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.level-section, .team-section, .teammate-info, .ad-container {
  margin-bottom: 16px;
  background: white;
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.08);
  border: 1px solid #eaeaea;
}
.section-title, .teammate-title {
  font-size: 16px;
  margin-bottom: 15px;
  padding: 6px 7px;
  background: linear-gradient(135deg, #1e5aa5, #2a6dc5);
  color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 5px;
  box-shadow: 0 2px 3px rgba(30, 90, 165, 0.2);
}
.team-info-sign {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 7px;
  background: #f8f9fa;
  border-radius: 5px;
  border-left: 2px solid #1e5aa5;
}

.team-name-sign {
  font-size: 16px;
  font-weight: bold;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 5px;
}

.teamType{
  font-size: 14px;
  color: #1e5aa5;
  font-weight: bold;
}

.level-btn, .modify-btn, .score-btn {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
}

.level-btn.submitted {
  background: #FF9800;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(255, 152, 0, 0.3);
}

.level-btn.selecting {
  background: green;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(244, 67, 54, 0.3);
}

.level-btn.unsubmitted {
  background: #1e5aa5;
  color: white;
}

.modify-btn {
  background: #F44336;
  color: white;
}
.score-buttons {
  display: flex;
  gap: 6px;
}
.selected {
  background: #ff9800;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(255, 152, 0, 0.3);
}

.selecting {
  background: green;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(244, 67, 54, 0.3);
}

 .unselected {
  background: #3bcdf1;
  color: white;
}
.disabled {
  background: #ccc;
  color: #999;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transform: none;
}
.teammate-card {
  background: #f8f9fa;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
  border-left: 2px solid #1e5aa5;
}

.teammate-table {
  font-weight: bold;
  margin-bottom: 6px;
  font-size: 16px;
  color: #1e5aa5;
  display: flex;
  align-items: center;
  gap: 4px;
}

.teammate-score {
  color: #2c3e50;
  margin-bottom: 6px;
  font-size: 16px;
  font-weight: 600;
  font-weight: bold;
}

.level-indicators {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.level-indicator {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 16px;
  font-weight: bold;
}

.total-score{
  margin-top: 20px;
  padding: 10px  15px;
  font-size: 18px;
  color: #ffff;
  background-color: #1e5aa5;
  text-align: center;
  border-radius: 5px;
}

</style>


// WEBPACK FOOTER //
// src/views/team/TeamSign.vue